import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

window.$ = window.jQuery = require('jquery')

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faSignal, faMusic, faClock, faDownload, faEye, faEyeSlash, faAngleLeft, faAngleRight, faBars, faAngleDown, faAngleUp, faPlayCircle, faFilePdf, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";

Vue.component("font-awesome-icon", FontAwesomeIcon);

library.add([faCheckCircle, faSignal, faMusic, faClock, faDownload, faEye, faEyeSlash, faAngleLeft, faAngleRight, faBars, faAngleDown, faAngleUp, faPlayCircle, faFilePdf, faUnlockAlt ]);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
